import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Footer from "../footer";
import NavBar from "../nav";

const SearchDetails = () => {
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate('/');
  }

  return <div className='search-details'>
    <NavBar />
    <div className='search-details__item'>
      <div className='search-details__back' onClick={navigateBack}>
        <FontAwesomeIcon icon={faChevronLeft} />Back to Search Results
      </div>
      <p className='search-details__item--article'>Article Title</p>
      <p className='search-details__item--sub-header'>Sub Header</p>
      <p className='search-details__item--content'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed odio dui. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.

        Donec sed odio dui. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Nullam quis risus eget urna mollis ornare vel eu leo. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.

        Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed odio dui. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.

        Nulla vitae elit libero, a pharetra augue. Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur purus sit amet fermentum. Vestibulum id ligula porta felis euismod semper. Donec ullamcorper nulla non metus auctor fringilla.</p>
      <p className='search-details__item--related-article-title'>Related Articles</p>
      <div className='search-details__item--related-article'>
        <span>
          <p>Article Title</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. </p>
          <p className='a'>View More</p>
        </span>
        <span>
          <p>Article Title</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. </p>
          <p className='a'>View More</p>
        </span>
        <span>
          <p>Article Title</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. </p>
          <p className='a'>View More</p>
        </span>
      </div>
    </div>
    <Footer />
  </div>
}

export default SearchDetails